angular.module("digitalLeasing.module").component("ratingCgs", {
    templateUrl: "ng/components/digitalLeasing/ratingDetail/ratingCgs/ratingCgs.view.html",
    bindings: {
        ratingCustomer: "=",
        percentualeGaranzia: "=",
        percentualeGaranziaPredefinita: "=",
        message: "=",
        askForSelection: "&?",
        confirm: "=",
        componentIsOk: "&"
    },
    controllerAs: "ratingCgsCtrl",
    controller: function RatingCgs(
        $timeout
    ) {
        var self = this;
        self.ratingKO = false;

        self.$onInit = function() {
            if (self.message === "LBL_PREV_ANN_RATING_KO") {
                self.ratingKO = true;
                // self.confirm = false;
                self.handleChange();
            }
        }

        self.handleChange = function () {
            self.askForSelection({selection : self.confirm});
            self.componentIsOk({validity: true});
        }
    },
})